import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { MdKeyboardArrowDown } from "react-icons/md";
import { motion, useAnimation, useInView } from "framer-motion";

const FAQ = () => {
  const [activeAnswer, setActiveAnswer] = useState(null);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation1 = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation1.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);

  return (
    <Container>
      <div className="title">
        <h1>FAQ</h1>
        <p>
          Këto janë 4 pyetjet më të zakonshme që na bëjne klientat tonë. Nëse ke
          ndonjë pytje, mos hezito dhe <Link to={"/contact"}>Na Kontakto</Link>
        </p>
      </div>
      <div ref={ref} className="questions">
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.3, type: "spring" }}
          className={activeAnswer === 1 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 1 ? null : 1)}
        >
          <span>
            <h2>Sa vonon porosia? </h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>
            Porosia vonon 1-2 ditë pune në Kosovë, ndërsa Shqipëri dhe Maqedoni
            3-5 ditë pune.
          </p>
        </motion.div>

        <hr />
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.5, type: "spring" }}
          className={activeAnswer === 3 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 3 ? null : 3)}
        >
          <span>
            <h2>Sa kushton posta?</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>Posta në Kosovë është Falas, ndërsa Shqipëri dhe Maqedoni 3€.</p>
        </motion.div>
        {/* <hr />
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.7, type: "spring" }}
          className={activeAnswer === 4 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 4 ? null : 4)}
        >
          <span>
            <h2>Lorem ipsum dolor sit amet?</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Reprehenderit iusto doloremque libero quos quasi.
          </p>
        </motion.div>
        <hr />
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.9, type: "spring" }}
          className={activeAnswer === 2 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 2 ? null : 2)}
        >
          <span>
            <h2>Lorem ipsum dolor sit amet?</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Reprehenderit iusto doloremque libero quos quasi.
          </p>
        </motion.div> */}
      </div>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 4%;
  background-image: var(--bgGradient4);
  .title {
    text-align: center;
    h1 {
      font-weight: 100;
      font-size: 4.7em;
      font-family: "Nanum Myeongjo", serif;
    }
    p {
      width: 60%;
      margin: auto;
      margin-top: 1em;
      color: var(--fontSecondaryColor);
      font-weight: 300;
    }
  }
  .questions {
    transition: 0.4s;
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin: 2em 0;
    align-items: center;
    hr {
      width: 80%;
      border: none;
      border-top: 1px solid #cacaca;
    }
    .row {
      transition: 0.4s;
      height: 30px;
      width: 80%;
      cursor: pointer;
      span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h2 {
          color: #154926;
          font-weight: 400;
          font-size: 18px;
        }
        .icon {
          font-size: 2em;
          color: var(--primaryColor);
        }
      }
      p {
        display: none;
      }
    }

    .active {
      transition: 0.4s;
      height: 50px;
      width: 80%;
      cursor: pointer;
      p {
        transition: 0.4s;
        display: flex;
        color: var(--fontSecondaryColor);
        font-weight: 300;
      }
      span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h2 {
          font-weight: 500;
          font-size: 20px;
          transition: 0.4s;
        }
        .icon {
          transform: rotate(180deg);
          font-size: 2em;
          color: var(--primaryColor);
        }
      }
    }
  }
  @media (max-width: 1170px) {
    .questions {
      hr {
        width: 97%;
      }
      .row {
        width: 98%;
      }
      .active {
        width: 98%;
      }
    }
  }
  @media (max-width: 780px) {
    .questions {
      .row {
        h2 {
          font-size: 1.4em;
        }
      }
      .active {
        width: 98%;
        height: 70px;
        h2 {
          font-size: 1.4em;
        }
        p {
          line-height: 20px;
        }
      }
    }
  }
  @media (max-width: 680px) {
    .questions {
      .row {
        height: 40px;
        h2 {
          line-height: 24px;
        }
      }
    }
  }

  @media (max-width: 380px) {
    .questions {
      .row {
      }
      .active {
        height: 90px;
      }
    }
  }
`;

export default FAQ;
